import Router from 'next/router';

import { getAnnouncementLinkHref } from '@air/feature-announcements';

export const openAnnouncementLink = (url: string) => {
  const href = getAnnouncementLinkHref(url);

  if (!href) {
    return;
  }

  if (href.startsWith('https://')) {
    window.open(href, '_blank', 'noopener,noreferrer');
  } else {
    void Router.push(href);
  }
};
